var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Fire Alarm History","subtitle":"ประวัติระบบแจ้งเหตุเพลิงไหม้","icon":"mdi-chart-line","icon-color":"error","breadcrumb":"Reports"}},[_c('FireAlarmHistoryFilter'),_c('FireAlarmHistoryDataTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }